export function DronerPin({ color }) {
  return (
    <svg
      width="30"
      height="43"
      viewBox="0 0 30 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.7356 15.7059C29.7356 27.9906 15.3656 43 15.3656 43C15.3656 43 0.995667 27.9906 0.995667 15.7059C0.995667 7.03179 6.97582 0 15.3656 0C23.7555 0 29.7356 7.03179 29.7356 15.7059Z"
        fill={color}
      />
      <ellipse cx="15.3656" cy="14" rx="5.9462" ry="6" fill="white" />
    </svg>
  );
}
